import React, { Component } from 'react';
//components

//styles
import './scss/main.scss';
import Carusel from '../Carusel/Carusel';
import Header from '../Header/Header';


class Main extends Component {
  render() {
    return (
        <div className="main-container">
            <Header sendGA={this.props.sendGA} bgColor={'transparent'} height={'100px'} isDecade={false} opacity={1}/>        
            <div className="main-image"></div>
            <div className="main-text">
                <div className="smaller-text">
                    מערכות קשות והפגנות סוערות, חגיגות לאומיות, צחוק ודמעות. 
                    <div className="bigger-text">
                         מורה נבוכים ל-70 שנות עצמאות
                    </div>
                </div>
                <div className="credit">
                ניהול הפרויקט: נועה גליקשטיין קרן ואור רוזנטל נתן. עריכה: נעם גיל, דניאלה רגב, גלעד כרמלי, ירון דרוקמן ודרור עמיר
                </div>
                <div className="desc">
                    בחרו עשור וקראו על האירועים הגדולים שעיצבו את פני המדינה
                </div>
            </div>
            <Carusel vPush={this.props.vPush} decadesJSON={this.props.decadesJSON} sendGA={this.props.sendGA}/>
        </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/Components/Main/Main.js